// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import style from './404.scss';
import buttonStyle from '../../../../assets/styles/button.scss';
import yogi from '../../../../assets/img/yogi-400.png';
import { Status } from '../../../../router';

const NotFound = () => (
  <Status code={404}>
    <section className={style.notFoundWrap}>
      <article className={style.notFoundContent}>
        <img src={yogi} alt="Yogi"/>
        <aside>
          <h2>404</h2>
          <FormattedMessage id="notFound.title">
            {txt => <h3>{txt}</h3>}
          </FormattedMessage>
          <FormattedMessage id="notFound.text">
            {txt => <p>{txt}</p>}
          </FormattedMessage>
          <Link to="/" className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}>
            <FormattedMessage id="notFound.button"/>
          </Link>
        </aside>
      </article>
    </section>
  </Status>
);

export default NotFound;


// WEBPACK FOOTER //
// ./src/modules/error/components/404/404.jsx